import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import PageNavbar from "components/PageNavbar";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Card from "@mui/material/Card";
import { Grid } from "@mui/material";
import { IoDocumentText } from "react-icons/io5";

// Configure the external server URL
const IFRAME_URL = "https://docarc.zainlee.com/";

function DocumentArchiving() {
  return (
    <DashboardLayout>
      <PageNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card
                sx={{
                  height: "100%",
                  background: "linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.49) 76.65%)",
                  backdropFilter: "blur(120px)",
                  border: "2px solid rgba(255, 255, 255, 0.125)",
                  borderRadius: "20px",
                  padding: "20px",
                }}
              >
                {/* Header */}
                <VuiBox display="flex" alignItems="center" mb={3}>
                  <VuiBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      background: "linear-gradient(97.89deg, #0075ff, #0075ff)",
                      width: "50px",
                      height: "50px",
                      borderRadius: "12px",
                      marginRight: "15px",
                    }}
                  >
                    <IoDocumentText size="24px" color="white" />
                  </VuiBox>
                  <VuiBox>
                    <VuiTypography variant="h4" color="white" fontWeight="bold">
                      Document Archiving
                    </VuiTypography>
                    <VuiTypography variant="button" color="text" fontWeight="regular">
                      Manage and archive your documents
                    </VuiTypography>
                  </VuiBox>
                </VuiBox>

                {/* Iframe Container */}
                <VuiBox
                  sx={{
                    width: "100%",
                    height: "calc(100vh - 200px)",
                    borderRadius: "12px",
                    overflow: "hidden",
                    background: "#0a0e23",
                  }}
                >
                  <iframe
                    src={IFRAME_URL}
                    title="Document Archiving Dashboard"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      borderRadius: "12px",
                    }}
                    allow="camera; microphone; fullscreen; accelerometer; gyroscope; magnetometer"
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
                  />
                </VuiBox>
              </Card>
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DocumentArchiving;



